// Categories of scenarios for the left column (um/2026-10-30/03 п.9): the rail section of the trigger's section of records, then that
// section of records itself — «События → Заказы», «CRM → Сделки». A trigger without a section goes to «Общие».

import { menuPlace, type AutomationDef, type MenuSection, type MetaIndex } from '@confdeck/core-shared';

export interface Category {
  key: string; label: string; icon: string; types: { typeId: string; label: string; count: number }[]; count: number;
  /** Sections of records named like the category itself («Билеты» in «Билеты»): no branch of their own, the category row stands for them. */
  folded: string[];
}

export const triggerType = (a: AutomationDef): string | undefined => ('typeId' in a.trigger ? a.trigger.typeId : undefined);
export const OTHER = 'other';

/** Sections in the order of the rail, each with its sections of records that have scenarios; «Общие» last. */
export function categories(list: AutomationDef[], menu: MenuSection[], meta: MetaIndex): Category[] {
  const out = new Map<string, Category>();
  const other: Category = { key: OTHER, label: 'Общие', icon: 'zap', types: [], count: 0, folded: [] };
  for (const a of list) {
    const tid = triggerType(a);
    const sec = tid ? menuPlace(menu, (n) => n.typeIds.includes(tid))?.section : undefined;
    const c = sec ? out.get(sec.key) ?? { key: sec.key, label: sec.label, icon: sec.icon, types: [], count: 0, folded: [] } : other;
    if (sec) out.set(sec.key, c);
    c.count++;
    if (tid && sec) {
      const label = meta.type(tid)?.nameMany ?? '—';
      // «Билеты → Билеты», «Программа → Программа»: the same name twice in the column reads as a repeat (quality eval 30.10).
      if (label === c.label) { if (!c.folded.includes(`t:${tid}`)) c.folded.push(`t:${tid}`); continue; }
      const t = c.types.find((x) => x.typeId === tid);
      if (t) t.count++; else c.types.push({ typeId: tid, label, count: 1 });
    }
  }
  const order = menu.map((m) => m.key);
  return [...[...out.values()].sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key)), ...(other.count ? [other] : [])];
}

/** The scenarios of a category: a section of records (`t:<id>`), a rail section (its key), or all. */
export function inCategory(list: AutomationDef[], cat: string | null, menu: MenuSection[]): AutomationDef[] {
  if (!cat) return list;
  if (cat.startsWith('t:')) return list.filter((a) => triggerType(a) === cat.slice(2));
  return list.filter((a) => {
    const tid = triggerType(a);
    const sec = tid ? menuPlace(menu, (n) => n.typeIds.includes(tid))?.section.key : undefined;
    return cat === OTHER ? !sec : sec === cat;
  });
}
